// extracted by mini-css-extract-plugin
module.exports = {"loader":"c+HuZ","header-image":"UidFZ","nav-container":"Kkb7D","missing-menu":"QZGuz","footer":"dRCjR","footer-link":"IeyU6","header":"zLB-9"};